import { LegalLayout } from "./components/legalLayout";
import { PAYMENT_ATTRIBUTION } from "./content/paymentAttribution";

/** /como-a-fidexa-conta-pagamentos — quando um pagamento conta como ajuda da Fidexa. */
export const ComoAFidexaContaPagamentos = () => (
  <LegalLayout document={PAYMENT_ATTRIBUTION} />
);
